import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import DataTable from 'components/Treasury/DataTable/DataTable';
import DataUserBill from 'components/Treasury/DataUserBill/DataUserBill';
import Loading from 'uI/Loading/Loading';
import LoginForm from 'components/LoginForm/LoginForm';
import FormContainer from 'uI/FormContainer/FormContainer';
import PaymentCard from 'components/Treasury/PaymentCard/PaymentCard';

import {
  cfdiBilling,
  getPayments,
  userDataBilling
} from 'store/treasury-actions';

import classes from './Treasury.module.css';

const Treasury = () => {
  const { t } = useTranslation(['login']);
  const dataUser = useSelector(state => state.userInfo);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(true);
  const [openBill, setOpenBill] = useState(false);
  const [cfdi, setCfdi] = useState(true);
  const [userPayments, setUserPayments] = useState(true);

  useEffect(() => {
    (async () => {
      setUserInfo(await userDataBilling());
      setCfdi(await cfdiBilling());
      setUserPayments(await getPayments());
      setLoading(false);
    })();
  }, []);

  const openBillHandler = () => {
    setOpenBill(true);
  };

  const closeDialogHandler = () => {
    setOpenBill(false);
  };

  return (
    <div className={classes.treasuryContainer}>
      {dataUser.data.systemDate &&
        (dataUser.data.usuario ? (
          <>
            {!loading ? (
              <>
                <div className={classes.titleContainer}>
                  <p className={classes.title}>Tesorería</p>
                </div>
                <Button
                  className={classes.billingDataBtn}
                  onClick={openBillHandler}
                >
                  Datos de Facturación
                </Button>
                <div className={classes.dataMovil}>
                  <PaymentCard data={userPayments[1]} charges />
                  <PaymentCard data={userPayments[2]} />
                </div>
                <div className={classes.dataDesktop}>
                  <DataTable data={userPayments[1]} charges />
                  <DataTable data={userPayments[2]} />
                </div>
              </>
            ) : (
              <Loading />
            )}
            {openBill && (
              <DataUserBill
                userInfo={userInfo}
                cfdi={cfdi}
                open={openBill}
                close={closeDialogHandler}
              />
            )}
          </>
        ) : (
          <FormContainer
            title={t('principal_text')}
            btnLink="register"
            login
          >
            <LoginForm prevUrl="treasury" />
          </FormContainer>
        ))}
    </div>
  );
};

export default Treasury;
